import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setAngularJSGlobal } from '@angular/upgrade/static';
import * as angular from 'angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Boostrap angular application
 */
setAngularJSGlobal(angular);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log(`Application started`))
  .catch(err => console.error(`Application error during bootstrapping \n ${err} \n ${JSON.stringify(err)}`));
